import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import BarChartIcon from '@mui/icons-material/BarChart';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

const UploadDocumentCard = () => {
  return (
    <StyledCard elevation={2}>
      <UploadDocumentContent>
        <ContentWrapper>
          <UploadIconBox>
            <UploadFileIcon sx={{ fontSize: { xs: 28, sm: 36 }, color: "#896E3B" }} />
          </UploadIconBox>
          <TextContent>
            <TitleWrapper>
              <Typography 
                variant="h6" 
                fontWeight="bold" 
                sx={{ 
                  fontSize: { xs: '1.1rem', sm: '1.25rem' },
                  ml: { xs: 0.5, sm: 1 }
                }}
              >
                שיפור תנאי המשכנתא שלך בקלות
              </Typography>
              <WorkspacePremiumIcon sx={{ 
                color: '#FFD700', 
                fontSize: { xs: 20, sm: 24 }
              }} />
            </TitleWrapper>
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{
                fontSize: { xs: '0.875rem', sm: '0.9rem' },
                lineHeight: { xs: 1.5, sm: 1.6 }
              }}
            >
              העלה את דוח היתרות לסילוק וקבל ניתוח מקצועי וחינמי לחיסכון אפשרי בהוצאות המשכנתא שלך.
              טעינת הדוח חוסכת זמן רב, מונעת טעויות הקלדה ומאפשרת שמירת נתוני המשכנתא בצורה מדויקת ואמינה.
            </Typography>
          </TextContent>
        </ContentWrapper>
        <UploadButton component={Link} to="/UploadPage">
          <BarChartIcon sx={{ mr: 1, fontSize: { xs: 18, sm: 20 } }} />
          בדיקה חינמית
        </UploadButton>
      </UploadDocumentContent>
    </StyledCard>
  );
};

// Styled Components
const StyledCard = styled(Paper)`
  margin-top: 32px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  background: linear-gradient(to right, #FBFAF8, #F8F5F0);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    height: 3px;
    width: 100%;
    background: linear-gradient(to right, #C9B18C, #E9DBC8);
  }

  @media (max-width: 600px) {
    margin-top: 24px;
    border-radius: 10px;
  }
`;

const UploadDocumentContent = styled(Box)`
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 16px;
  }
`;

const ContentWrapper = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex: 1;

  @media (max-width: 600px) {
    gap: 12px;
  }
`;

const TextContent = styled(Box)`
  flex: 1;
`;

const TitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  @media (max-width: 600px) {
    margin-bottom: 6px;
  }
`;

const UploadIconBox = styled(Box)`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(201, 177, 140, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  @media (max-width: 600px) {
    width: 48px;
    height: 48px;
  }
`;

const UploadButton = styled(Button)`
  background-color: #896E3B;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 500;
  text-transform: none;
  box-shadow: 0 4px 12px rgba(137, 110, 59, 0.15);
  white-space: nowrap;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  align-self: center;
  
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.2);
    transition: width 0.3s ease;
    z-index: 1;
  }
  
  & > * {
    position: relative;
    z-index: 2;
  }
  
  &:hover {
    background-color: #A38547;
    box-shadow: 0 6px 15px rgba(137, 110, 59, 0.3);
    transform: translateY(-2px);
    
    &::after {
      width: 120%;
    }
  }
  
  &:active {
    transform: translateY(0);
    background-color: #735a31;
  }
  
  @media (max-width: 600px) {
    width: 100%;
    padding: 10px 16px;
    font-size: 0.9rem;
  }
`;

export default UploadDocumentCard; 